export default __webpack_public_path__ + "static/media/Icon-Close-Btn.2658c28d.svg";